import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-book-read-line"></i>
                </span>
                <span className="font-heading font-bold text-lg text-background-50">
                  土豪漫画网
                </span>
              </Link>
              <p className="text-sm leading-relaxed text-background-50/60">
                专注韩漫推荐、日漫大全、国漫排行榜的漫画分类网站。
                实时更新好看的漫画，满足各类漫画爱好者的需求。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">漫画分类</h4>
              <ul className="space-y-2.5">
                {[
                  { to: '/category/韩漫推荐', label: '韩漫推荐' },
                  { to: '/category/日漫大全', label: '日漫大全' },
                  { to: '/category/国漫排行榜', label: '国漫排行榜' },
                ].map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速链接</h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">首页</Link></li>
                <li><Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200">关于我们</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">联系我们</h4>
              <ul className="space-y-2.5 text-sm text-background-50/60">
                <li className="flex items-center gap-2">
                  <i className="ri-mail-line text-primary-400"></i>
                  <span>contact@tuhaomanhua.com</span>
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-primary-400"></i>
                  <span>北京市朝阳区漫画创意园</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 土豪漫画网 版权所有
            </p>
            <p className="text-xs text-background-50/40">
              本站内容仅供漫画爱好者交流学习使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}